import { FileText } from 'lucide-react'

import CardOne from '../common/card/CardOne'

interface IIncompleteReportListItemProps {
  order: number
}

const IncompleteReportListItem = ({ order }: IIncompleteReportListItemProps) => {
  return (
    <CardOne className=' bg-body/80'>
      <div className='flex items-center justify-between mb-2'>
        <div className='flex items-center gap-2'>
          <FileText className='w-5 h-5 text-amber-600' />
          <h3 className='text-base font-bold text-gray-800'>{order}회차</h3>
        </div>
      </div>

      <div className='space-y-1'>
        <p className='text-xs text-gray-500'>리포트 생성중...</p>
      </div>
    </CardOne>
  )
}

export default IncompleteReportListItem
